/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import React from "react";

const Hdfc = () => {
  return (
    <>
      <title>Untitled Document</title>
      <table
        style={{ margin: "0 auto", border: 0 }}
        width={1024}
      >
        <tbody>
          <tr>
            <td>
              <img
                alt="hdfc-landing-page"
                height={850}
                src="https://i.wlycdn.com/wealthy-home-page/hdfc-life-landing-page.jpg"
                useMap="#Map"
                width={1024}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <map name="Map">
        <area
          coords="62,455,156,482"
          href="https://www.hdfclife.com/term-insurance-plans"
          shape="rect"
          target="_blank"
        />
        <area
          coords="257,187,51"
          href="https://www.hdfclife.com/term-insurance-plans"
          shape="circle"
          target="_blank"
        />
        <area
          coords="224,583,316,610"
          href="https://www.hdfclife.com/savings-investment-plans"
          shape="rect"
          target="_blank"
        />
        <area
          coords="355,327,52"
          href="https://www.hdfclife.com/savings-investment-plans"
          shape="circle"
          target="_blank"
        />
        <area
          coords="669,591,762,618"
          href="https://www.hdfclife.com/health-insurance-plans"
          shape="rect"
          target="_blank"
        />
        <area
          coords="675,322,60"
          href="https://www.hdfclife.com/health-insurance-plans"
          shape="circle"
          target="_blank"
        />
        <area
          coords="435,608,529,634"
          href="https://www.hdfclife.com/retirement-and-pension-plans"
          shape="rect"
          target="_blank"
        />
        <area
          coords="517,378,58"
          href="https://www.hdfclife.com/retirement-and-pension-plans"
          shape="circle"
          target="_blank"
        />
        <area
          coords="822,456,915,481"
          href="https://www.hdfclife.com/children-insurance-plans"
          shape="rect"
          target="_blank"
        />
        <area
          coords="761,188,62"
          href="https://www.hdfclife.com/children-insurance-plans"
          shape="circle"
          target="_blank"
        />
        <area
          coords="22,10,127,86"
          href="https://www.hdfclife.com"
          shape="rect"
          target="_blank"
        />
      </map>
    </>
  );
};

export default Hdfc;
